module.exports = __webpack_public_path__ + "img/20200313120232QQ截图20190624162056.95820ff9.png";